import React from 'react';
import { useLocation } from 'react-router-dom';

const stripTrailingSlash = (path) => path.length > 1 ? path.replace(/\/+$/, '') : path;

// Fallback for link lists that don't define their own per-item `icon` (see
// the header's DropdownItemIcon, which this matches for a consistent look
// wherever a page hasn't been given more specific icons yet).
const DefaultLinkIcon = () => (
    <svg className="mr-2 flex-none text-gray-400" width="0.9em" height="0.9em" viewBox="0 0 24 24" fill="none"
         xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const LandingSidebar = ({title, links}) => {
    const location = useLocation();

    return (
        <section
            className="pt-20 pl-4 border-gray-200 lg:block lg:col-span-2 2xl:col-span-2 pb-24 pr-6 border-r border-t border-gray-100 landing-sidebar-gradient">
            <div className="flex flex-wrap flex-col xl:flex-row mb-5 border-b border-gray-100 pb-3">
                <nav aria-label={title}>
                    {title &&
                        <div className="font-mono text-lg font-normal leading-tight text-blue-800 mb-2">{title}</div>}
                    <ul className="space-y-1">
                        {links.map((link, index) => {
                            const isActive = stripTrailingSlash(location.pathname) === stripTrailingSlash(link.to);
                            return (
                                <li key={index}>
                                    <a href={link.to}
                                       className={`flex items-center text-base no-underline dropdown-menu-text dark:text-blue-400 dark:hover:text-gray-400 ${isActive ? 'font-semibold' : 'font-normal hover:text-red-700'}`}>
                                        {link.icon || <DefaultLinkIcon/>}
                                        {link.label}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </section>
    );
};

export default LandingSidebar;
